import { Item } from 'baseui/side-navigation';
import { Key } from 'react';
import { useRecoilValue } from 'recoil';
import {
  CORE_PAGE_IDS
} from '../constants/app';
import { authUserPanelPagesState, pageState } from '../storage/app';

export function useSidenavItems(items: Item[]) {
  const currentPage = useRecoilValue(pageState);
  const panelPages = useRecoilValue(authUserPanelPagesState);

  const pageSection: Key | undefined = (() => {
    return undefined;
  })();

  const sections: any[] = (() => {
    return [];
  })();

  const coreItems = (() => {
    const itemsCore = items.filter((item) => (item.itemId ? CORE_PAGE_IDS.includes(item.itemId) : false));
    if (!panelPages || panelPages.length === 0) 
      return itemsCore
    const panelsCore = items.filter((item) => (item.itemId ? panelPages.map((page) => page.id).includes(item.itemId) : false));
    return [...itemsCore, ...panelsCore];
  })();

  return {
    pageSection,
    coreItems,
    sections,
  };
}
